var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h2',{staticClass:"diviser"},[_vm._v(" Partes ")]),_c('div',{staticClass:"m-t"},[_vm._v(" Partes não cadastradas ")])])
}]

export { render, staticRenderFns }